import _0x422629 from'./createTheme';const defaultTheme=_0x422629();export default defaultTheme;